import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Chip } from 'shared/mui/Chips';
import { Stack } from 'shared/mui/Stack/Stack';
import { EmbeddedFunctionField, FunctionField } from 'shared/react-admin/Fields';
import { Link } from 'shared/react-admin/Links/Link';
import { GatewayRule } from 'types/embedded/gatewayRule';
import { Merchant } from 'types/embedded/merchant';
import { formatInputInTz } from 'utils/date';

export const GatewayRulesShowChipFields = () => {
  const translate = useTypedTranslate();
  const { createPathWithQuery } = useCreatePathWithQuery();
  const { hasResourceAccess } = usePermissions();

  return (
    <Stack direction="row" flexWrap="wrap" gap={1} sx={{ marginBottom: '24px' }}>
      <EmbeddedFunctionField
        render={(originId: string) => <Chip label={`ID: ${originId}`} size="small" />}
        sourceField="originId"
      />
      <EmbeddedFunctionField
        render={(name: string) => <Chip label={`Название: ${name}`} size="small" />}
        sourceField="name"
      />
      {hasResourceAccess('merchants') && (
        <EmbeddedFunctionField
          render={(merchant: Merchant) => (
            <Chip
              label={
                <div>
                  {translate('app.table.merchant')}:{' '}
                  <Link
                    to={createPathWithQuery({
                      resource: 'merchants',
                      id: merchant?.['@id'],
                      type: 'show',
                    })}
                  >
                    {merchant.name}
                  </Link>
                </div>
              }
              size="small"
            />
          )}
          sourceField="merchant"
        />
      )}
      <FunctionField
        render={(record: GatewayRule) => (
          <Chip
            label={`${translate('app.table.createdAt')}: ${formatInputInTz(record.createdAt, { format: 'dd.MM.yyyy, HH:mm' })}`}
            size="small"
          />
        )}
      />
      <FunctionField
        render={(record: GatewayRule) => (
          <Chip
            label={`${translate('app.table.updatedAt')}: ${formatInputInTz(record.updatedAt, { format: 'dd.MM.yyyy, HH:mm' })}`}
            size="small"
          />
        )}
      />
    </Stack>
  );
};
